module.exports = __webpack_public_path__ + "static/hero-4dabc3569a3c8c1fc3a5ea4d735c4a91.png";